import React, { Component } from 'react';

// Import Images
import teamMember1 from '../../images/team/member7.webp';
import teamMember2 from '../../images/team/member8.webp';
import teamMember3 from '../../images/team/member9.webp';
import ptImg1 from '../../images/shap/trangle-orange.png';
import ptImg2 from '../../images/shap/square-dots-orange.png';
import ptImg3 from '../../images/shap/line-circle-blue.png';
import ptImg4 from '../../images/shap/wave-blue.png';
import ptImg5 from '../../images/shap/circle-dots.png';

const teamMembers = [
	{
		name: 'Dr. Ananya Sharma',
		specialization: 'General Medicine & Preventive Checkups',
		image: teamMember1,
		// socialMedia: [
		// 	{ platform: 'Twitter', link: 'https://twitter.com/' },
		// 	{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
		// 	{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		// ],
	},
	{
		name: 'Dr. Arjun Mehra',
		specialization: 'Physiotherapy & Diagnostics',
		image: teamMember2,
		// socialMedia: [
		// 	{ platform: 'Twitter', link: 'https://twitter.com/' },
		// 	{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
		// 	{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		// ],
	},
	{
		name: 'Dr. Priya Nair',
		specialization: 'Pediatrics & Specialized Consultations',
		image: teamMember3,
		// socialMedia: [
		// 	{ platform: 'Twitter', link: 'https://twitter.com/' },
		// 	{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
		// 	{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		// ],
	},
];

class TeamSection extends Component{
	render(){
		return(
			<>
				
				<section className="section-area section-sp3 team-wraper">
					<div className="container">
						<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Our Doctor</h6>
							<h2 className="title">Meet the Best Doctors at <br/>Avenra Health Center</h2>
						</div>
						<div className="row justify-content-center">
							{teamMembers.map((teamMember, index) => (
								<div key={index} className="col-lg-4 col-sm-6 mb-30">
									<div className="team-member h-100">
										<div className="team-media">
											<img src={teamMember.image} alt={teamMember.name} />
										</div>
										<div className="team-info">
											<div className="team-info-content">
												<h4 className='text-primary' style={{fontSize:"18px"}}>{teamMember.name}</h4>
												<span>{teamMember.specialization}</span>
											</div>
											{/* <ul className="social-media mt-3">
												{teamMember.socialMedia.map((social, index) => (
													<li key={index}>
														<a rel="noreferrer" target="_blank" href={social.link}>
															<i className={`fab fa-${social.platform.toLowerCase()}`} />
														</a>
													</li>
												))}
											</ul> */}
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
					<img className="pt-img1 animate1" src={ptImg1} alt=""/>
					<img className="pt-img2 animate2" src={ptImg2} alt=""/>
					<img className="pt-img3 animate-rotate" src={ptImg3} alt=""/>
					<img className="pt-img4 animate-wave" src={ptImg4} alt=""/>
					<img className="pt-img5 animate-wave" src={ptImg5} alt=""/>
				</section>
				
			</>
		);
	}
}

export default TeamSection;